import {HttpContextToken} from '@angular/common/http';

export const SKIP_CANCEL_ON_NAV = new HttpContextToken<boolean>(() => false);
